import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/dashboard")),
  },
  // Proaksi Konten
  {
    key: "proaksi",
    path: `${APP_PREFIX_PATH}/proaksi/konten`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/konten"),
    ),
  },
  {
    key: "proaksi-detail",
    path: `${APP_PREFIX_PATH}/proaksi/konten/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/konten/detail"),
    ),
  },
  {
    key: "proaksi-form",
    path: `${APP_PREFIX_PATH}/proaksi/konten/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/konten/form"),
    ),
  },
  // Proaksi Top Konten
  {
    key: "top-proaksi",
    path: `${APP_PREFIX_PATH}/proaksi/top-konten`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/top-konten"),
    ),
  },
  {
    key: "top-proaksi-detail",
    path: `${APP_PREFIX_PATH}/proaksi/top-konten/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/top-konten/detail"),
    ),
  },
  {
    key: "top-proaksi-form",
    path: `${APP_PREFIX_PATH}/proaksi/top-konten/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/top-konten/form"),
    ),
  },
  // Export
  {
    key: "proaksi-export",
    path: `${APP_PREFIX_PATH}/proaksi/export`,
    component: React.lazy(
      () => import("views/app-views/member/proaksi/konten/export"),
    ),
  },
  // Pelaporan Medsos
  {
    key: "pelaporan-medsos",
    path: `${APP_PREFIX_PATH}/media-sosial/pelaporan`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/pelaporan"),
    ),
  },
  {
    key: "pelaporan-medsos-detail",
    path: `${APP_PREFIX_PATH}/media-sosial/pelaporan/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/pelaporan/detail"),
    ),
  },
  {
    key: "pelaporan-medsos-form",
    path: `${APP_PREFIX_PATH}/media-sosial/pelaporan/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/pelaporan/form"),
    ),
  },
  // Kolaborasi Medsos
  {
    key: "kolaborasi-medsos",
    path: `${APP_PREFIX_PATH}/media-sosial/kolaborasi`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/kolaborasi"),
    ),
  },
  {
    key: "kolaborasi-medsos-detail",
    path: `${APP_PREFIX_PATH}/media-sosial/kolaborasi/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/kolaborasi/detail"),
    ),
  },
  {
    key: "kolaborasi-medsos-form",
    path: `${APP_PREFIX_PATH}/media-sosial/kolaborasi/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/kolaborasi/form"),
    ),
  },
  // Blast Medsos
  {
    key: "media-sosial/blast",
    path: `${APP_PREFIX_PATH}/media-sosial/blast`,
    component: React.lazy(
      () => import("views/app-views/member/media-sosial/blast"),
    ),
  },
  // Rank
  {
    key: "rank-medsos-pelaporan",
    path: `${APP_PREFIX_PATH}/ranking/media-sosial/pelaporan`,
    component: React.lazy(
      () => import("views/app-views/ranking/medsos/pelaporan"),
    ),
  },
  {
    key: "rank-medsos-kolaborasi",
    path: `${APP_PREFIX_PATH}/ranking/media-sosial/kolaborasi`,
    component: React.lazy(
      () => import("views/app-views/ranking/medsos/kolaborasi"),
    ),
  },
  {
    key: "rank-proaksi-konten",
    path: `${APP_PREFIX_PATH}/ranking/proaksi/konten`,
    component: React.lazy(
      () => import("views/app-views/ranking/proaksi/konten"),
    ),
  },
  {
    key: "rank-proaksi-top-konten",
    path: `${APP_PREFIX_PATH}/ranking/proaksi/top-konten`,
    component: React.lazy(
      () => import("views/app-views/ranking/proaksi/top-konten"),
    ),
  },
  // User
  {
    key: "user",
    path: `${APP_PREFIX_PATH}/user`,
    component: React.lazy(() => import("views/app-views/user")),
  },
  {
    key: "user-detail",
    path: `${APP_PREFIX_PATH}/user/detail/:id`,
    component: React.lazy(() => import("views/app-views/user/detail")),
  },
  {
    key: "user-form",
    path: `${APP_PREFIX_PATH}/user/form/:id?`,
    component: React.lazy(() => import("views/app-views/user/form")),
  },
  // Manajemen Satker
  {
    key: "master-data-satker",
    path: `${APP_PREFIX_PATH}/master-data/satker`,
    component: React.lazy(() => import("views/app-views/master-data/satker")),
  },
  {
    key: "master-data-satker-form",
    path: `${APP_PREFIX_PATH}/master-data/satker/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/master-data/satker/form"),
    ),
  },
  // Manajemen Tier
  {
    key: "master-data-tier",
    path: `${APP_PREFIX_PATH}/master-data/tier`,
    component: React.lazy(() => import("views/app-views/master-data/tier")),
  },
  {
    key: "master-data-tier-form",
    path: `${APP_PREFIX_PATH}/master-data/tier/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/master-data/tier/form"),
    ),
  },
  // Role & Permissions
  // {
  //   key: "role-permissions",
  //   path: `${APP_PREFIX_PATH}/role-permissions`,
  //   component: React.lazy(() => import("views/app-views/role-permissions")),
  // },
  // {
  //   key: "role-permissions-form",
  //   path: `${APP_PREFIX_PATH}/role-permissions/form`,
  //   component: React.lazy(
  //     () => import("views/app-views/role-permissions/form"),
  //   ),
  // },
  // Settings
  {
    key: "change-profile",
    path: `${APP_PREFIX_PATH}/settings/change-profile`,
    component: React.lazy(
      () => import("views/app-views/settings/change-profile"),
    ),
  },
  {
    key: "change-password",
    path: `${APP_PREFIX_PATH}/settings/change-password`,
    component: React.lazy(
      () => import("views/app-views/settings/change-password"),
    ),
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
];
